import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PullToRefreshAdmin from "@/components/PullToRefreshAdmin";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PageEditor from "@/pages/PageEditor";
import PublicPage from "@/pages/PublicPage";
import Account from "@/pages/Account";
import LandingPage from "@/pages/LandingPage";
import LandingEditor from "@/pages/LandingEditor";

function AdminShell({ children }) {
  return (
    <ProtectedRoute>
      <PullToRefreshAdmin>{children}</PullToRefreshAdmin>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/p/:slug" element={<PublicPage />} />
          <Route
            path="/dashboard"
            element={
              <AdminShell>
                <Dashboard />
              </AdminShell>
            }
          />
          <Route
            path="/pages/new"
            element={
              <AdminShell>
                <PageEditor />
              </AdminShell>
            }
          />
          <Route
            path="/pages/:id"
            element={
              <AdminShell>
                <PageEditor />
              </AdminShell>
            }
          />
          <Route
            path="/landing"
            element={
              <AdminShell>
                <LandingEditor />
              </AdminShell>
            }
          />
          <Route
            path="/account"
            element={
              <AdminShell>
                <Account />
              </AdminShell>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
